import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';
import { OrderType } from 'models/order.model';
import moment from 'moment';
import { ENUM_STATUS } from 'utils/enum';

type CalcDeliveryTimeType = {
  order: OrderType;
  orderStatus: ENUM_STATUS;
  role: ENUM_ROLE;
};

type CalTotalKitchenTimeType = {
  order: OrderType;
  orderStatus: ENUM_STATUS;
};
export const calculateDeliveryTime = ({ order, orderStatus, role }: CalcDeliveryTimeType) => {
  let diffObj = {
    text: '',
    time: ''
  };
  if (orderStatus === ENUM_STATUS.UNPAID && order?.estimated_unpaid_time) {
    diffObj = {
      text: 'Estimated unpaid time',
      time: order.estimated_unpaid_time
    };
  } else if (
    [ENUM_STATUS.PENDING, ENUM_STATUS.PROCESSING, ENUM_STATUS.LATE].includes(orderStatus) &&
    order?.estimated_kitchen_time
  ) {
    diffObj = {
      text: 'Estimated kitchen time',
      time: order.estimated_kitchen_time
    };
  } else if (orderStatus === ENUM_STATUS.READY && order?.estimated_frontdesk_time) {
    diffObj = {
      text: 'Estimated frontdesk time',
      time: order.estimated_frontdesk_time
    };
  } else if (
    (orderStatus === ENUM_STATUS.ONGOING ||
      (role === ENUM_ROLE.LOGISTICS_SUPER_ADMIN && orderStatus === ENUM_STATUS.LATE)) &&
    order?.estimated_delivery_time
  ) {
    diffObj = {
      text: 'Estimated delivery time',
      time: order.estimated_delivery_time
    };
  }
  return diffObj;
};

export const calTotalKitchenTime = ({ order, orderStatus }: CalTotalKitchenTimeType) => {
  const isOngoing = orderStatus === ENUM_STATUS.ONGOING;
  const isReady = orderStatus === ENUM_STATUS.READY;
  if (isOngoing && !(order?.kitchen_accepted_time && order?.kitchen_dispatched_time)) return 0;
  if (isReady && !(order?.kitchen_accepted_time && order?.kitchen_completed_time)) return 0;
  const acceptedTime = moment(order?.kitchen_accepted_time);
  const dispatchTime = moment(order?.kitchen_dispatched_time);
  const completedTime = moment(order?.kitchen_completed_time);
  if (isReady) return completedTime.diff(acceptedTime, 'minutes');
  return dispatchTime.diff(acceptedTime, 'minutes');
};

export const getDeliveryType = (order: OrderType) => {
  if (order?.preorder || order?.preorder_delivery_datetime || order?.preorder_delivery_time) {
    return 'Pre-order';
  }
  if (order?.scheduled || order?.scheduled_delivery_time || order?.scheduled_delivery_datetime) {
    return 'Scheduled';
  }
  return '';
};

export const getValidDeliveryDate = (primaryDate: string | null, fallbackDate: string | null) =>
  moment(primaryDate).isValid() ? primaryDate : fallbackDate;

export const getOrderDateTime = (order: OrderType) => {
  const timeDates = order?.preorder_delivery_time ?? order?.scheduled_delivery_time;
  if (moment(timeDates).isValid()) return timeDates;

  return timeDates?.split(' - ');
};
